import { SENTRY_CONFIG } from '@fukuri-admins/constants/common';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: SENTRY_CONFIG.dsn,
  environment: SENTRY_CONFIG.environment,
  release: SENTRY_CONFIG.release,

  // パフォーマンス設定
  tracesSampleRate: 0.1,

  // セッションリプレイ設定
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // 最小構成（APIエラー監視）
  integrations: [Sentry.browserTracingIntegration()],

  // 開発環境設定
  debug: false,

  // アプリ識別
  initialScope: {
    tags: {
      app: 'partner-admin',
    },
  },

  // セキュリティ設定
  sendDefaultPii: false,
});

declare global {
  interface Window {
    testSentryError?: () => void;
  }
}

// 開発環境でのテスト用
if (import.meta.env.DEV) {
  console.log('✅ Sentry initialized for PARTNER-ADMIN app');
  window.testSentryError = () => {
    Sentry.captureException(new Error('Test error from partner-admin app'));
    console.log('🚀 Test error sent to Sentry dashboard');
  };
}
